module.exports = __webpack_public_path__ + "media/images/img_opportunity02-b09cac9f37eaa4c9693e731a217b129c.png";